// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"3.915\" height=\"6.83\" viewBox=\"0 0 3.915 6.83\"> <path d=\"M6,9l2.708,2.708L11.416,9\" transform=\"translate(-8.293 12.123) rotate(-90)\" fill=\"none\" stroke=\"#bdbdbd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1\"/> </svg> ";
// Exports
module.exports = code;